import { Component, OnInit } from '@angular/core';

import { LoginService } from '../../services/login.service';
import { MailValidatorService } from 'src/app/shared/services/mail-validator.service';

@Component({
    selector: 'app-forgot-password',
    templateUrl: './forgot-password.component.html',
    styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {

    public forgotButtonLabel: string = 'Recuperar contraseña';
    public loginLabel       : string = 'Volver a login';
    public loginUrl         : string = '/login';

    public email               : string;
    public isValidEmail        : boolean;
    public emailValidationError: string;

    public showResetPasswordSuccessAlert: boolean = false;
    public passwordSuccessMessage: string = 'El correo de recuperación de contraseña se ha enviado correctamente. Recuerde revisar la carpeta de SPAM.';

    public isProcessing : boolean = false;
    public errorMessage: string;

    constructor(private loginService: LoginService, private mailValidatorService: MailValidatorService) { }

    ngOnInit() { }

    public onEmailChange() {

        if (this.email === null && this.email === "") {
            this.email                = null;
            this.isValidEmail         = false;
            this.emailValidationError = null;
            return;
        }

        let emailValidation       = this.mailValidatorService.validate(this.email);
        this.isValidEmail         = emailValidation.success;
        this.emailValidationError = this.isValidEmail ? null : emailValidation.message;

    }

    public isFormValid() : boolean {

        return this.email && this.email !== null && this.email !== '' && this.isValidEmail;

    }

    restorePassword() {

        this.isProcessing = true;
        this.errorMessage = null;

        this.loginService.resetPassword(this.email)
            .subscribe({

                next: (result: boolean) => {

                    if (result) {
                        this.showResetPasswordSuccessAlert = true;
                        this.email = null;
                    } else {
                        this.errorMessage = 'Error desconocido';
                    }

                },

                error: (error: string) => {
                    this.errorMessage = error;
                }

            })
            .add(() => {
                this.isProcessing = false;
            });

    }

    public resetFormMessages() {

        this.isProcessing  = false;
        this.errorMessage = null;
        this.showResetPasswordSuccessAlert = false;

    }

}
